import React from "react";
import { Box, SpaceBetween } from "@amzn/awsui-components-react";

export interface PlaceholderPanelProps {
  readonly featureName: string;
}

export const PlaceholderPanel: React.FC<PlaceholderPanelProps> = ({
  featureName,
}) => {
  return (
    <Box
      data-testid={`placeholder-panel-${featureName}`}
      padding={{ vertical: "l" }}
    >
      <SpaceBetween size="xs">
        <Box variant="h2">{featureName}</Box>
        <Box variant="p" color="text-body-secondary">
          Coming soon
        </Box>
      </SpaceBetween>
    </Box>
  );
};

export default PlaceholderPanel;
